import {
  getPinOnImageResultsRequest,
  getPinOnImageResultsResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/pin-on-image-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchPinOnImageResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchPinOnImageResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseFetchPinOnImageResultsParams) => {
  const requestParams = { interactiveContentId };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey(adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getPinOnImageResultsRequest,
    getResponse: getPinOnImageResultsResponse,
  });
};
